import { Component, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import {
  SeriesLabelsContentArgs,
  LegendItemClickEvent,
} from '@progress/kendo-angular-charts';
import { ChartComponent } from 'ng-apexcharts';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexMarkers,
  ApexFill,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
  ApexStroke,
  ApexAnnotations,
} from 'ng-apexcharts';
import { LoaderService } from '../../core/services/loader.service';
import { DashboardService } from '../../core/services/dashboard.service';
import { SharedService } from '../../shared/shared.service';
import { superadmin_graphColors, SweetAlertIcon } from '../../shared/constants/enum';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  stroke: ApexStroke;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  fill: ApexFill;
  annotations?: ApexAnnotations;
  colors: any;
};

interface XAxisRange {
  min: number;
  max: number;
}

interface UpdateOptionsData {
  [key: string]: {
    xaxis: XAxisRange;
  };
}

@Component({
  selector: 'app-sgld-admindashboard',
  templateUrl: './sgld-admindashboard.component.html',
  styleUrl: './sgld-admindashboard.component.scss',
  standalone: false,
})
export class SgldAdmindashboardComponent {
  deviceCountData: any;
  deviceCOuntinfographData: any[] = [];
  totalDeviceCOunt: number = 0;
  deviceCountStatusLoading: boolean = true;
  deviceCountStatusNoDate: boolean = false;

  notificationCountData: any;
  deviceNotificationGraphdata: { category: string; value: number }[] = [];
  monthlydeviceNotificationGraphdata: any[] = [];
  totalNotificationCount: number = 0;
  deviceNotificationGraphDataLoding: boolean = true;
  devicemonthlyNotificationGraphDataLoding: boolean = true;
  deviceNotificationStatusGraphNoData: boolean = false;
  isLeakChartShow: boolean = false;
  isSelectMonths = 'Current Month';
  selectedRange = 'Current Month';

  public selectedDateRangeLeak: {
    startDate: string;
    endDate: string;
  } | null = null;

  convertedData: any[] = [];
  seriesVisible = true;

  colors = superadmin_graphColors;
  selectedProject: any[] = [];

  public leakmonths: Array<string> = [
    'Current Month',
    'Last Month',
    'Last Three Months',
    'Last Six Months',
  ];

  public updateOptionsData: UpdateOptionsData = {
    'Current Month': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
    'Last Month': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
    'Last Three Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
    'Last Six Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 5,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
  };

  @ViewChild('chart', { static: false }) chart?: ChartComponent;
  public chartOptions: ChartOptions = {
    series: [],
    chart: {
      type: 'area',
      height: 250,
    },
    dataLabels: { enabled: false },
    markers: { size: 0 },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: [] },
    yaxis: { title: { text: '' } },
    tooltip: {},
    colors: ['#008FFB'],
    fill: { type: 'gradient' },
  };

  constructor(
    private loaderService: LoaderService,
    private dashboardService: DashboardService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.initApis();
    this.leakNotificationselectionChange('Current Month');
  }

  initApis() {
    this.deviceCountStatusLoading = true;
    this.deviceCountStatusNoDate = false;
    this.dashboardService
      .getSuperAdmindeviceCountData(this.selectedProject)
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            this.deviceCountData = res.data;
            this.deviceCountInfomationData();
          } else {
            this.totalDeviceCOunt = 0;
            this.deviceCountStatusLoading = false;
            this.deviceCountStatusNoDate = true;
          }
        },
        error: (err) => {
          this.deviceCountStatusLoading = false;
          this.deviceCountStatusNoDate = true;
          this.loaderService.setLoading(false);
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';
          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR
          );
        },
      });
  }

  LeakDetectionIdentifier(dateRange: any) {
    const request = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      ProjectIds: this.selectedProject,
    };
    this.deviceNotificationGraphDataLoding = true;
    this.dashboardService.getDeviceNotificationCountData(request).subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          this.notificationCountData = res.data;
          this.deviceNotificationData(this.notificationCountData);
        } else {
          this.deviceNotificationStatusGraphNoData = true;
          this.deviceNotificationGraphDataLoding = false;
        }
      },
      error: (err) => {
        this.deviceNotificationGraphDataLoding = false;
        this.deviceNotificationStatusGraphNoData = true;
        this.deviceNotificationGraphdata = [];
        this.loaderService.setLoading(false);
        const errorMsg =
          err.error?.message ||
          'Something went wrong. Please try again later.';
        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });
  }

  deviceCountInfomationData() {
    this.deviceCOuntinfographData = [];
    this.deviceCountStatusLoading = true;
    this.deviceCountStatusNoDate = false;
    this.totalDeviceCOunt = 0;

    const total = this.deviceCountData?.deviceStatusTotalCount;
    const projects = this.deviceCountData?.deviceStatusProjectCount;

    if (this.selectedProject.length === 0) {
      if (total) {
        this.totalDeviceCOunt = total.totalDevices;
        this.deviceCOuntinfographData = [
          {
            name: 'Only GSM Connected',
            value: total.gsmConnectedCount,
            color: this.colors[0],
          },
          {
            name: 'Both GSM and Wifi Connected',
            value: total.gsmWifiConnectedCount,
            color: this.colors[1],
          },
          {
            name: 'Only WIFI Connected',
            value: total.wifiConnectedCount,
            color: this.colors[2],
          },
          {
            name: 'Disconnected',
            value: total.disconnectedCount,
            color: this.colors[3],
          },
        ];
      } else {
        this.deviceCountStatusNoDate = true;
      }
    } else {
      if (!projects || projects.length === 0) {
        this.deviceCountStatusNoDate = true;
      } else {
        let gsmConnected = 0;
        let gsmWifiConnected = 0;
        let wifiConnected = 0;
        let disconnected = 0;

        this.selectedProject.forEach((projectId: any) => {
          const project = projects.find((p: any) => p.projectId === projectId);
          if (project) {
            gsmConnected += project.gsmConnectedCount;
            gsmWifiConnected += project.gsmWifiConnectedCount;
            wifiConnected += project.wifiConnectedCount;
            disconnected += project.disconnectedCount;
            this.totalDeviceCOunt += project.totalDevices;
          }
        });

        this.deviceCOuntinfographData = [
          { name: 'GSM Connected', value: gsmConnected, color: this.colors[0] },
          { name: 'GSM Wifi Connected', value: gsmWifiConnected, color: this.colors[1] },
          { name: 'WIFI Connected', value: wifiConnected, color: this.colors[2] },
          { name: 'Disconnected', value: disconnected, color: this.colors[3] },
        ];
      }
    }

    this.loaderService.setLoading(false);
    this.deviceCountStatusLoading = false;

    if (this.totalDeviceCOunt === 0) {
      this.deviceCountStatusNoDate = true;
    }
  }

  deviceNotificationData(data: any) {
    this.initChart();
    if (
      this.isSelectMonths == 'Last Three Months' ||
      this.isSelectMonths == 'Last Six Months'
    ) {
      this.isLeakChartShow = false;
      const monthlyWiseNotificationdata =
        this.leakconvertToMonthlyNotifications({
          notificationTotalCount: data.notificationTotalCount,
          dayWiseNotificationCount: data.dayWiseNotificationCount,
        });
      if (monthlyWiseNotificationdata.length > 0) {
        this.monthlyLeakNotificationChart(monthlyWiseNotificationdata);
      }
    } else {
      this.isLeakChartShow = true;
      this.loadConsumptionChart(data);
    }
  }

  initChart(): void {
    const startDate = this.selectedDateRangeLeak?.startDate
      ? new Date(this.selectedDateRangeLeak.startDate)
      : null;
    const dateDiff =
      startDate && this.selectedDateRangeLeak?.endDate
        ? new Date(this.selectedDateRangeLeak.endDate).getTime() -
        startDate.getTime()
        : 0;

    const dateFormat =
      dateDiff > 2 * 24 * 60 * 60 * 1000 ? 'dd MMM' : 'dd MMM HH:mm';

    this.chartOptions = {
      series: [
        {
          name: '',
          data: this.convertedData,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
        events: {
          mounted: (chart: any) => chart.windowResizeHandler(),
          dataPointMouseEnter: (event, chartContext, config) =>
            chartContext.chart.showTooltip(config.dataPointIndex),
        },
      },
      colors: ['#008FFB'],
      dataLabels: { enabled: false },
      markers: { size: 0 },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        type: 'datetime',
        min: startDate ? startDate.getTime() : undefined,
        max: this.selectedDateRangeLeak?.endDate
          ? new Date(this.selectedDateRangeLeak.endDate).getTime()
          : undefined,
        tickAmount: 3,
        title: { text: 'Dates' },
        labels: { format: dateFormat },
        tooltip: { enabled: false },
        crosshairs: { show: false },
      },
      yaxis: {
        title: { text: 'Count' },
      },
      tooltip: {
        x: { format: 'dd MMM yyyy' },
        y: { formatter: (value) => `${value}` },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    };
  }

  leakconvertToMonthlyNotifications(data: any): any[] {
    const items = Array.isArray(data) ? data : [data];

    return items.map((item: any) => {
      const totalNotificationCount = item.notificationTotalCount;
      const dailyData = item.dayWiseNotificationCount;
      if (!dailyData) return [];

      const monthlyData = Object.keys(dailyData).reduce(
        (acc: any, date: string) => {
          const [year, month] = date.split('-');
          const monthKey = `${year}-${month}`;

          if (!acc[monthKey]) {
            acc[monthKey] = {
              year: Number(year),
              month: Number(month),
              monthName: new Date(`${year}-${month}-01`).toLocaleString(
                'default',
                {
                  month: 'long',
                }
              ),
              totalCount: 0,
            };
          }

          acc[monthKey].totalCount += dailyData[date];
          return acc;
        },
        {}
      );

      return {
        totalNotificationCount,
        monthlyWiseNotificationCount: Object.values(monthlyData),
      };
    });
  }

  monthlyLeakNotificationChart(data: any) {
    this.devicemonthlyNotificationGraphDataLoding = true;
    this.monthlydeviceNotificationGraphdata = [];
    this.totalNotificationCount = data[0].totalNotificationCount;
    data[0].monthlyWiseNotificationCount.forEach((res: any, index: number) => {
      this.monthlydeviceNotificationGraphdata.push({
        category: res.monthName,
        value: Math.round(res.totalCount),
        colorString: this.colors[index],
      });
    });

    if (this.monthlydeviceNotificationGraphdata.length > 0) {
      this.devicemonthlyNotificationGraphDataLoding = false;
    }
  }

  loadConsumptionChart(notificationData: any) {
    this.deviceNotificationGraphdata = [];
    const consumptionData = notificationData?.dayWiseNotificationCount;
    this.totalNotificationCount = notificationData?.notificationTotalCount;

    for (const date in consumptionData) {
      if (consumptionData.hasOwnProperty(date)) {
        const value = consumptionData[date];
        this.deviceNotificationGraphdata.push({
          category: date,
          value: value,
        });
      }
    }
    const convertedData = this.deviceNotificationGraphdata.map((item) => [
      new Date(item.category).getTime(),
      item.value,
    ]);

    if (this.chartOptions.series && this.chartOptions.series[0].data) {
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[0].data = convertedData;
      this.convertedData = convertedData;

      this.deviceNotificationGraphDataLoding = false;
      this.initChart();
    }

    this.updateOptions(this.selectedRange);
    this.chart?.updateOptions(this.chartOptions, false, true, true);

    setTimeout(() => {
      this.deviceNotificationGraphDataLoding = false;
    }, 200);
  }

  public updateOptions(option: keyof UpdateOptionsData): void {
    const optionData =
      this.updateOptionsData[option as keyof typeof this.updateOptionsData];
    if (optionData) {
      this.chart?.updateOptions(optionData, false, true, true);
    }
  }

  public labelContent(e: SeriesLabelsContentArgs): string {
    return e.value;
  }

  public onLegendItemClick(e: LegendItemClickEvent): void {
    e.preventDefault();
    this.seriesVisible = !this.seriesVisible;
  }

  leakNotificationselectionChange(event: any) {
    const selectedOption = event;
    const now = new Date();
    let startDate = new Date(now);
    let endDate = new Date(now);

    switch (selectedOption) {
      case 'Current Month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date();
        endDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Month':
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Three Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Six Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;
      default:
        break;
    }

    this.selectedRange = selectedOption;
    this.selectedDateRangeLeak = {
      startDate: formatDate(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
    };
    this.LeakDetectionIdentifier(this.selectedDateRangeLeak);
  }
}